const THEME_KEY = "selectedTheme";
import { busEmit } from "@/composables/eventBus";

/**
 * Get the current theme preference
 * @returns {'light' | 'dark' | 'auto'}
 */
export function getThemePreference() {
  return localStorage.getItem(THEME_KEY) || "auto";
}

/**
 * Set the theme preference
 * @param {'light' | 'dark' | 'auto'} theme
 */
export function setThemePreference(theme) {
  localStorage.setItem(THEME_KEY, theme);
  applyTheme(theme);
}

/**
 * Check if system prefers dark mode
 * @returns {boolean}
 */
function systemPrefersDark() {
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
}

/**
 * Apply the theme to the document
 * @param {'light' | 'dark' | 'auto'} theme
 */
export function applyTheme(theme) {
  const isDark = theme === "dark" || (theme === "auto" && systemPrefersDark());

  if (isDark) {
    document.documentElement.classList.add("dark");
    busEmit("themeChanged", { value: "dark" });
  } else {
    document.documentElement.classList.remove("dark");
    busEmit("themeChanged", { value: "light" });
  }
}

/**
 * Get the current active theme
 * @returns {'light' | 'dark'}
 */
export function currentTheme() {
  return document.documentElement.classList.contains("dark") ? "dark" : "light";
}

/**
 * Initialize theme on app start
 * Sets up the theme and listens for system preference changes
 */
export function initTheme() {
  const theme = getThemePreference();
  applyTheme(theme);

  // Listen for system theme changes when in auto mode
  window
    .matchMedia("(prefers-color-scheme: dark)")
    .addEventListener("change", () => {
      const currentTheme = getThemePreference();
      if (currentTheme === "auto") {
        applyTheme("auto");
      }
    });
}
